import {
	AnalystsEstimatesChartTimeFrame,
	type TableColumn,
} from "@/components/widgets/Revision/types";

const MAX_QUARTERS = 4;
const MAX_ANNUALS = 3;

export const timeFramesForSelection = (
	timeFrameType: AnalystsEstimatesChartTimeFrame,
	ee?: TableColumn[],
): string[] => {
	const result = [];
	let timeFrameQuantity = 0;
	if (!ee?.length || timeFrameType == null) {
		return [];
	}
	if (timeFrameType === AnalystsEstimatesChartTimeFrame.QUARTERS) {
		for (const element of ee) {
			if (
				element.type === AnalystsEstimatesChartTimeFrame.QUARTERS &&
				timeFrameQuantity < MAX_QUARTERS
			) {
				result.push(`${element.type}${element.quarter}/${element.year}`);
				timeFrameQuantity++;
			}
		}
	}
	if (timeFrameType === AnalystsEstimatesChartTimeFrame.ANNUALS) {
		for (const element of ee) {
			if (
				element.type === AnalystsEstimatesChartTimeFrame.ANNUALS &&
				timeFrameQuantity < MAX_ANNUALS
			) {
				result.push(`${element.type}/${element.year}`);
				timeFrameQuantity++;
			}
		}
	}

	return result;
};
